// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3llqj","left":"InfoRow_left__21_L9"};